import * as Yup from "yup";
import { validation, conditionalValidation } from "../../../utils/constants"

export const questionnaireTagOptions = [
    { value: "none", name: "None" },
    { value: "opening", name: "Opening" },
    { value: "closing", name: "Closing" },
];

export const questionnaireForOptions = [
    // { value: "Service Request", name: "Service Request" },
    { value: "clinical-visit", name: "Clinical Visit" },
    { value: "getcare-waitingroom", name: "Get Care - Waiting Room" },
    { value: "telephone-intake", name: "Intake - Inbound Call" },
    // { value: "contact-center", name: "Contact Center" },
];

export const categoryOptions = [
    { value: "Chief Complaint", name: "Chief Complaint" },
    { value: "Medical History", name: "Medical History" },
    { value: "Conditions", name: "Conditions" },
    { value: "Medications", name: "Medications" },
    { value: "Allergies", name: "Allergies" },
    { value: "Immunizations", name: "Immunizations" },
    { value: "Assessment", name: "Assessment" },
    { value: "Impression", name: "Impression" },
    { value: "Plan", name: "Plan" },
    { value: "Flags", name: "Flags" },
    { value: "Additional Notes", name: "Additional Notes" },
];

export const answerTypeOptions = [
    { value: "freeText", name: "Multi Line Text" },
    { value: "singleFreeText", name: "Single Line Text" },
    { value: "dropDown", name: "Dropdown" },
    { value: "checkbox", name: "Checkbox" },
    { value: "radio", name: "Radio" },
]

export const comTypeOptions = [
    { value: "Video", name: "Video" },
    { value: "Chat", name: "Chat" },
]

export const intiallCategorySelectedQuestions = {
    "Chief Complaint": [],
    "Medical History": [],
    Conditions: [],
    Medications: [],
    Allergies: [],
    Immunizations: [],
    Assessment: [],
    Impression: [],
    Plan: [],
    Flags: [],
    "Additional Notes": [],
}

export const addRow = ({ formik}) => {
    const newRow = { id: Date.now(), text: "" };
    formik.setFieldValue("options", [...formik.values.options, newRow]);
};

export const removeRow = ({ index, formik}) => {
    const updatedOptions = formik.values.options.filter((_, i) => i !== index);
    formik.setFieldValue("options", updatedOptions);
};

export const handleFormChange = ({ e, formik }) => {
    if (e?.target?.id === "category") {
        const inputCategoryString = e.target.value;
        const parts = inputCategoryString.split('%');
    }
}

export const QuestionsFormikObj = {
    initialValues: {
        category: "",
        question:  "",
        answerType: "freeText",
        note: "",
        tag: "",
        options: [{
            id: Date.now(),
            text: "",
        }],
        required: false,
    },
    validationSchema: Yup.object({
        category: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                validation,
                label: "Category",
                mandatory: true
            }),
       
        question: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.').max(100, "Must be 100 characters or less"),
            {
                validation,
                label: "Question",
                mandatory: true
            }),
        answerType: conditionalValidation(
            Yup.string().required('Please fill the Answer Type field').matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                mandatory: true,
                label: "Answer Type",
                validation
            }),
        note: conditionalValidation(
            Yup.string().when("answerType", (answerType, schema) => {
                if (answerType === "freeText" || answerType === "singleFreeText") return schema.required('Please fill the Note field')
                    .matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.')
                return schema}).max(250, "Must be 250 characters or less"),
            {
                validation,
                label: "Note"
            }),
        required: Yup.boolean(),
        options: Yup.array().when("answerType", (answerType, schema) => {
            if (answerType !== "freeText" && answerType !== "singleFreeText") return schema.of(
                Yup.object().shape({
                    text: conditionalValidation(
                        Yup.string(),
                    {
                        mandatory: true,
                        validation,
                        label: "Answer"
                    })
                })
            )
            return schema
        }),
    }),
}

export const QuestionsFormikObjEdit = {
    initialValues: {
        category: "",
        question:  "",
        answerType: "freeText",
        note: "",
        tag: "",
        options: [{
            id: Date.now(),
            text: "",
        }],
        required: false,
    },
    validationSchema: Yup.object({
        category: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                mandatory: true,
                label: "Category",
                validation
            }),
        question: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.').max(100, "Must be 100 characters or less"),
            {
                mandatory: true,
                label: "Question",
                validation
            }),
        answerType: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                mandatory: true,
                label: "Answer Type",
                validation                
            }),
        note: conditionalValidation(
            Yup.string().when("answerType", (answerType, schema) => {
            if (answerType === "freeText" || answerType === "singleFreeText") return schema.required('Please fill the Note field').matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.')
            return schema}),
            {
                label: "Note",
                validation
            }),
        required: Yup.boolean(),
        options: Yup.array().when("answerType", (answerType, schema) => {
            if (answerType !== "freeText" && answerType !== "singleFreeText") return schema.of(
                Yup.object().shape({
                    text: conditionalValidation(
                        Yup.string(),
                        {
                            validation,
                            mandatory: true,
                            label: "Answer"
                        })
                })
            )
            return schema
        }),
    }),
}

export const QuestionnaireFormikObj = {
    initialValues: {
        title: "",
        type: "questionnaire",
        required: false,
        isDefault: false,
        note: "note",
        purpose: "clinical-visit",
        questionnaireTag: "none",
        status:"active" // unknown active  draft
    },
    validationSchema: Yup.object({
        title: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.').max(50, "Must be 50 characters or less"),
            {
                validation,
                label:"Title",
                mandatory: true
            }),
        // keyString: Yup.string().required('Please fill the Key String field').matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
        // questionnaireFor: Yup.string().required('Please select the Questionnaire For field'),
        type: conditionalValidation(
            Yup.string().required('Please fill the Type field').matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                validation,
                label:"Type",
                mandatory: true                
            }),
        //note: Yup.string().required('Please fill the Type field').matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
        required: Yup.boolean(),
        isDefault: Yup.boolean(),
        // question: Yup.array().required('Select any one question'),
        // question: Yup.array().min(1, 'Select any one question'),
        //question: Yup.array()
        //    .required('Select at least one question')
        //    .min(1, 'Select at least one question'),
    }),

}

export const QuestionnaireFormikObjEdit = {
    initialValues: {
        title: "",
        type: "questionnaire",
        required: false,
        isDefault: false,
        note: "",
        purpose: "",
        questionnaireTag: "none",
    },
    validationSchema: Yup.object({
                title: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.').max(50, "Must be 50 characters or less"),
            {
                validation,
                label:"Title",
                mandatory: true
            }),
        // keyString: Yup.string().required('Please fill the Key String field').matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
        //  questionnaireFor: Yup.string().required('Please select the Questionnaire For field'),
        type: conditionalValidation(
            Yup.string().required('Please fill the Type field').matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                validation,
                label:"Type",
                mandatory: true                
            }),
         //note: Yup.string().required('Please fill the Type field').matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
         required: Yup.boolean(),
         isDefault: Yup.boolean(),
        //question: Yup.array().min(1, 'Select any one question'),
    }),
}

export const iconStyle = {
    width: "35px",
    height: "35px",
    borderRadius: "10px",
    backgroundColor: "rgba(0, 93, 168, 0.12)",
    textAlign: "center",
    display: 'flex',
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
}

export const QuestionCategoryFormikObj = {
    initialValues: {
        categoryName: "",
        categoryType: "",

    },
    validationSchema: Yup.object({
        categoryName: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.').max(50, "Must be 50 characters or less"),
            {
                validation,
                label: "Category Name",
                mandatory: true
            }),
        categoryType: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                validation,
                label: "Workflow",
                mandatory: true
            })

    }),
}

export const EditQuestionCategoryFormikObj = {
    initialValues: {
        categoryName: "",
        categoryType: "",

    },
    validationSchema: Yup.object({
        categoryName: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.').max(50, "Must be 50 characters or less"),
            {
                validation,
                label: "Category Name",
                mandatory: true
            }),
        categoryType: conditionalValidation(
            Yup.string().matches(/^\s*\S[\s\S]*$/, 'Only blankspaces is not valid.'),
            {
                validation,
                label: "Workflow",
                mandatory: true
            })
    }),
}

export const questionnaireForOptionsOrganization = [    
    { value: "getcare-waitingroom", name: "Get Care - Waiting Room" },
];

export const QuestionnaireFormikAssign = {
    initialValues: {
        questionnaireWroomField: "",
        questionnaireVvisitField:[],
        questionnaireInboundCallField: "",
        questionnaireContactCenter: [],
        type: "questionnaire",       
        purpose: "",       
    },
    validationSchema: Yup.object({
       //  questionnaire: Yup.string().required('Please select  field'),
       //  purpose: Yup.string().required('Please select field'),
    }),
}


// Inbound call
export const questionTagFreeTextOptions = [ 
    { value: "TELEPHONE", name: "Return Telephone Number" },
    { value: "CALLER", name: "Caller Name" },
     { value: "REASON", name: "Reason for Visit" },
   
   
];

export const questionTagRadioOptions = [    
    { value: "SELFCALLING", name: "Calling for yourself" },  
    { value: "CONSENT", name: "Patient Consent" },     
];

export const questionTagDropDownOptions = [    
    { value: "LOCATION", name: "Patient Location" },  
    { value: "RELATIONSHIP", name: "Relationship to patient" },  
    { value: "INCLINATION", name: "Patient Inclination"}
];

// Getcare 
export const questionTagFreeTextOptionsGetCare = [ 
    { value: "TELEPHONE", name: "Return Telephone Number" },   
     { value: "REASON", name: "Reason for Visit" },
   
   
];

export const questionTagRadioOptionsGetCare = [ 
    { value: "CHANNEL", name: "Preferred Channel" },   
];

export const questionTagDropDownOptionsGetCare = [    
    { value: "LOCATION", name: "Patient Location" },    
];

export const questionTagRadioOptionsVideoVisit = [
    { value: "COMPLIANCE", name: "Patient Compliance" },
];
